module.exports = __webpack_public_path__ + "static/media/gallery-section.be3b91c6.png";